
<template>
  <div class="entity-properties-row d-flex flex-wrap mb-1 align-baseline"
  :class="$vuetify.breakpoint.name">
      <label class="input-label pt-3 pb-1 pb-sm-2">{{ label }}</label>
      <div class="flex-grow-1">
      <slot>
        <span>{{property}}</span>
      </slot>
      </div>
  </div>
</template>
<style scoped>
.entity-properties-row{
  flex-flow: row;
}
.xs.entity-properties-row{
  flex-flow: column;
}


.entity-properties-row .input-label{
  width: 12em;
  font-weight: bolder;
  margin-right: 1em;
}

.xs.entity-properties-row .input-label{
  width: auto;
}

</style>
<script>
export default {
  name: 'EntityPropertiesRow',
  props: {
    label: {
      type:String,
    },
    property: {
      type:String,
    },
  },
};
</script>

